import { UserModel } from 'src/models/userModel'
import { ADD_USER, UsersActionsTypes } from '../types/usersActionsTypes'

export const addUser = (user: UserModel): UsersActionsTypes => ({
  type: ADD_USER,
  payload: user,
})
